import tw, { styled } from 'twin.macro';

import { Props } from './Link';

export const StyledLink = styled.a<Props>(({ inheritSize, unstyled, uncolored }) => [
	// Untyled styles are explicit to combat Bootstrap global styles
	unstyled
		? tw`hover:[text-decoration: none] hover:[color: inherit]`
		: uncolored
			? tw`text-gray-800 hover:[text-decoration: underline] hover:[color: inherit]`
			: tw`text-indigo-500 underline`,
	!inheritSize && tw`text-sm`,
	!unstyled && !uncolored && tw`hcontrast:text-indigo-900`,
]);
